import axios from "axios";

const BASE_URL = process.env.REACT_APP_BACKEND_URL || "";
const TOKEN_KEY = "cl_access_token";

export function getStoredToken() {
  try {
    return localStorage.getItem(TOKEN_KEY);
  } catch (_) {
    return null;
  }
}

export function setStoredToken(token) {
  try {
    if (token) localStorage.setItem(TOKEN_KEY, token);
    else localStorage.removeItem(TOKEN_KEY);
  } catch (_) {
    // ignore
  }
}

export const api = axios.create({
  baseURL: `${BASE_URL}/api`,
  // Cookies-in-iframe are unreliable across browsers. We use Bearer tokens
  // exclusively so we don't need credentials and avoid CORS preflights.
  withCredentials: false,
  headers: { "Content-Type": "application/json" },
});

api.interceptors.request.use((config) => {
  const token = getStoredToken();
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  // FormData (multipart): dejar que el navegador fije el boundary correcto.
  if (typeof FormData !== "undefined" && config.data instanceof FormData && config.headers) {
    if (typeof config.headers.delete === "function") config.headers.delete("Content-Type");
    delete config.headers["Content-Type"];
    delete config.headers["content-type"];
  }
  return config;
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return null;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

// Comprehensive error formatter: prefers server detail, falls back to network hints.
export function humanizeAxiosError(e) {
  const serverDetail = formatApiErrorDetail(e?.response?.data?.detail);
  if (serverDetail) return serverDetail;
  if (e?.response?.status) return `Error del servidor (${e.response.status}).`;
  // eslint-disable-next-line no-console
  console.error("[ConstruLink] request failed:", e);
  if (e?.message === "Network Error")
    return "No se pudo contactar al servidor (red o CORS bloqueado). Verifica tu conexión o extensiones del navegador.";
  return e?.message || "Ha ocurrido un error. Intenta nuevamente.";
}
